// @ts-nocheck
import moment from 'moment'

// // 创建全局过滤器-- 处理时间
export function formatTime(value) {
  return moment(value).format('YYYY-MM-DD:hh-mm-ss')
}

// 过滤数组变成2级菜单，把键名转换成多级菜单组件对应的数， {label: '', value: '', children: []}
export function filterList(list) {
  // list.forEach(item => {
  //   item.childTree.forEach(key => {
  //     delete key['childTree']
  //   })
  // })
  return JSON.parse(JSON.stringify(list).replace(/areaName/g, 'label').replace(/areaId/g, 'value').replace(/childTree/g, 'children'))
}

export function filterMenu(data) {
  if(data&&data.length){
    let array = data.map(item => {
      return {
        menuId:item.menu.menuId,
        path: item.menu.url,
        component:item.menu.url,
        meta: {
          title: item.menu.name,
          permits: item.permits ? item.permits.map(child => child.code) : null,
          sortNum: item.menu.sortNum,
          icon: item.menu.icon
        },
        name: item.menu.url,
        icon: item.menu.icon,
        permits: item.permits ? item.permits.map(child => child.code) : null,
        superId:item.menu.superId?item.menu.superId.trim():null,
        sortNum:item.menu.sortNum
          }
    })
    let childArr = array.filter(item => item.superId)
    // console.log(childArr,"lalala-child")
    let otherArr = array.filter(item => !item.superId)
    childArr.forEach(item => {
      // if(item.superId)
      for (let i = 0; i < otherArr.length; i++){
        if (item.superId == otherArr[i].menuId) {
          item.component = resolve => {
            require(['@/views/home/'+otherArr[i].component+'/'+item.component],resolve)
          }
          // resolve() => import(`@/views/home/${otherArr[i].component}/${item.component}`)
          
          if (!otherArr[i].children) {
            otherArr[i].children = []
          }
          otherArr[i].children.push(item)
          otherArr[i].children.sort((value1,value2)=>value1.sortNum-value2.sortNum)
        }
      }

    })
    otherArr.forEach(item => {
      item.component = ()=>import(`@/views/home/${item.path}`)
    })

    // console.log(array,"lalala")

    let array2 = otherArr.sort((value1, value2) => value1.sortNum - value2.sortNum)
    // console.log(otherArr, "lalala")
    
    return array2
    }
}
